import React, {Fragment,useContext,useEffect,useState} from "react";
import axios from "services/interceptor/Interceptor";
import FormSection from "components/sales/formSection/formSection";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import {Button} from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./modify.css";

const RetagInvoicePopup = ({
  showRetagInvoicePopup,
  employeeCreditLimit,
  employeeCreditRemaining,
  employeeResponsibleEmail,
  employeeResponsibleDepartment,
  employeeDepartmentId,
  employeeTeamName,
  employeeTeamId,
  onClosePopup = () => {},
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState([]);
  const [selectedInvoiceName, setSelectedInvoiceName] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  
  useEffect(() => {

    if (employeeResponsibleEmail && employeeResponsibleDepartment) {
  
      const fetchInvoiceData = async () => {

        const payload = {
            email: employeeResponsibleEmail,
            department: employeeResponsibleDepartment,
            team: employeeTeamName
        };
  
      const url = Config.creditPolicy.getEmployeeInvoiceListing;

        try {
          const { data } = await axios.get(url, {
            params: payload
          });
  
          if (data.response.status === 200) {
            const invoices = data.response.data.data.invoices;

            const dropdownData = invoices.map((item) => ({
              id: item.id,
              name: item.invoice_number
            }));

            setInvoiceList(dropdownData);
          }
        } catch (error) {
          console.error("Error while fetching invoices", error);
        }
    
      };

      if (employeeDepartmentId) {
  
        const fetchEmployees = async () => {
  
          const payload = {
              type: 'E',
              department_id: employeeDepartmentId,
              only_email: 1,
              team_id: employeeTeamId
          };
    
        const url = Config.creditPolicy.getCredits;
  
          try {
            const { data } = await axios.get(url, {
              params: payload
            });
    
            if (data.response.status === 200) {
              const employees = data.response.data.resultSets;
  
              const employeeDropdownData = employees.map((item) => ({
                id: item.email,
                name: item.employee_name
              }));
  
              setEmployeeList(employeeDropdownData);
            }
          } catch (error) {
            console.error("Error while fetching employees", error);
          }
        };
        fetchInvoiceData();
        fetchEmployees();
    }
    
    }
  },[employeeDepartmentId,employeeResponsibleEmail,employeeResponsibleDepartment]);  

  async function submit() {

    setIsLoading(true);
    setDisableSubmit(true);

    if(selectedEmployee == ''){
      toast.error("Select an employee to retag");
      setDisableSubmit(false);
      return false;
    }

    if (selectedInvoiceId.length === 0) {
        toast.error("Select invoices to retag");
        setDisableSubmit(false);
        return false;
    }

    if (selectedEmployee == employeeResponsibleEmail) {
        toast.error("Invalid retag request");
        setDisableSubmit(false);
        return false;
    }

    const payload = {
        old_email: employeeResponsibleEmail,
        new_email: selectedEmployee,
        department: employeeResponsibleDepartment,
        invoice_list: selectedInvoiceId,
        team: employeeTeamName,
        invoice_name: selectedInvoiceName
    };

    let url = Config.creditPolicy.retagInvoice;
    const {data} = await axios.post(url, payload);

    onClosePopup();

    if (data.response.data.status != true) {
      if (data?.response?.message) {
        setIsLoading(false);
        toast.error(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 400);
      } else {
        setIsLoading(false);
        toast.error("Some error occurred!");
        setDisableSubmit(false);
      }
    } else {
      setIsLoading(false);
      toast.success("Invoice Retagged Successfully");
      setDisableSubmit(false);
      setTimeout(() => {
        window.location.reload();
      }, 400);
    }

  }

const retagInvoiceData = () => {
    return (
      <div className="card">
        <div className="card-body">

          <div className="row mb-4">
            <div className="col-md-6">
              <p><strong>Current Credit Limit:</strong> Rs {employeeCreditLimit}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Credit Remaining:</strong> Rs {employeeCreditRemaining}</p>
            </div>
          </div>

          <div className="row mb-4">

            <div className="col-md-6 mb-3">
              <DropDownInput
                label="Select Invoice"
                data={invoiceList}
                required
                multipule={true}
                getIdValue={(val) => {
                    if (Array.isArray(val)) {
                        const selectedIds = val.map(v => v.id);
                        const selectedNames = val.map(v => v.name);
                        setSelectedInvoiceId(selectedIds);
                        setSelectedInvoiceName(selectedNames)
                    } else if (val && val.id) {
                        setSelectedInvoiceId([val.id]);
                        setSelectedInvoiceName([val.name])
                    }
                    else {
                        setSelectedInvoiceId([]);
                        setSelectedInvoiceName([]);
                    }
                }}
                isStarRequired={true}
              />
            </div>
  
            <div className="col-md-6 mb-3">
              <DropDownInput
                label="Retag Invoice To"
                data={employeeList}
                required
                getIdValue={(val) => {
                    setSelectedEmployee(val.id);
                }}
                isStarRequired={true}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Button
                className="btn-sm button-margin"
                onClick={submit}
                disabled={disableSubmit}>
                Retag Invoice
              </Button>
            </div>
          </div>

        </div>
      </div>
    );
  };  
   
  return (
    <>
      <ModalPop
        title={"Retag Invoice"}
        show={showRetagInvoicePopup}
        handleModalHide={() => {
          onClosePopup();
        }}
      >
        <Fragment>
            <div className="tab-pane fade show active"
            id="edit-profile"
            role="tabpanel"
            aria-labelledby="edit-profile-tab"
            >
            <FormSection>{retagInvoiceData()}</FormSection>
            </div>
            <div
            className="tab-pane fade"
            id="emails"
            role="tabpanel"
            aria-labelledby="emails-tab"
            >
            </div>
        </Fragment>
      </ModalPop>
    </>
  );
};

export default RetagInvoicePopup;
